import { render, staticRenderFns } from "./CheckoutsIndex.vue?vue&type=template&id=6bdd8a18&scoped=true"
import script from "./CheckoutsIndex.vue?vue&type=script&lang=js"
export * from "./CheckoutsIndex.vue?vue&type=script&lang=js"
import style0 from "./CheckoutsIndex.vue?vue&type=style&index=0&id=6bdd8a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdd8a18",
  null
  
)

export default component.exports